module.exports = __webpack_public_path__ + "static/media/photo105.600bc4a2.jpg";